import { render, staticRenderFns } from "./DataPopup.vue?vue&type=template&id=4be48f57&scoped=true&"
import script from "./DataPopup.vue?vue&type=script&lang=js&"
export * from "./DataPopup.vue?vue&type=script&lang=js&"
import style0 from "./DataPopup.vue?vue&type=style&index=0&id=4be48f57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be48f57",
  null
  
)

export default component.exports